var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgListWithDotVertical = function SvgListWithDotVertical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgListWithDotVertical",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgListWithDotVertical{fill:#B5B5B5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path_listWithDotVertical",
    className: "svgListWithDotVertical svgBase svgHover svgSelect",
    d: "M13.4,3.3c0,1.2,0.7,2.3,1.9,2.8v12.9c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7 c0,0,0,0,0,0V6.2c1.6-0.2,2.8-1.7,2.6-3.3c-0.2-1.6-1.7-2.8-3.3-2.6C14.5,0.5,13.4,1.8,13.4,3.3z M17.8,3.3c0,0.8-0.7,1.5-1.5,1.5 c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5C17.2,1.8,17.8,2.5,17.8,3.3C17.8,3.3,17.8,3.3,17.8,3.3z M6.6,19V6.3 c0,0,0-0.1,0-0.1c1.6-0.4,2.6-2,2.2-3.6C8.4,0.9,6.8,0,5.2,0.4C3.6,0.8,2.6,2.4,3,4c0.3,1.1,1.1,1.9,2.2,2.2c0,0,0,0.1,0,0.1V19 c0,0.4,0.3,0.7,0.7,0.7S6.6,19.4,6.6,19C6.6,19,6.6,19,6.6,19L6.6,19z M4.4,3.3c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5 c0,0.8-0.7,1.5-1.5,1.5C5.1,4.8,4.4,4.1,4.4,3.3C4.4,3.3,4.4,3.3,4.4,3.3z M11.9,19v-6.7c0-0.4-0.3-0.7-0.7-0.7 c-0.4,0-0.7,0.3-0.7,0.7V19c0,0.4,0.3,0.7,0.7,0.7C11.5,19.7,11.9,19.4,11.9,19z M2.2,19v-6.7c0-0.4-0.3-0.7-0.7-0.7 s-0.7,0.3-0.7,0.7c0,0,0,0,0,0V19c0,0.4,0.3,0.7,0.7,0.7S2.2,19.4,2.2,19C2.2,19,2.2,19,2.2,19z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListWithDotVertical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list_with_dot_vertical.b0eabaee.svg";
export { ForwardRef as ReactComponent };